import React from "react";
import { useGlobalContext } from "../Context/GlobalContext";
import BestDataMaster from "./Best data/BestDataMaster";
import DRMDiaryMaster from "./DRMDiry/Old____________DRMDiaryMaster";
import SevenALoadingMaster from "./7ALoading/SevenALoadingMaster";
import AssetFailureMaster from "./AssetFailuer/AssetFailureMaster";
import OtherMaster from "./Others/OtherMaster";
// import InsMaster from "./INS_SUMMERY/InsMaster";
import CompsMaster from "./DRMDiry/Comps.jsx/CompsMaster";
import MilestoneMaster from "./Milestone/MilestoneMaster";
import NKJYardExMaster from "./Others/NKJYardEx/NKJYardExMaster";
import PunctualityNavMaster from "./PunctualityFolder/PunctualityNavMaster";
import OperatingPerformance from "./OperatingPerformance/OperatingPerformance";
import CIMaster from "./ComparativeInterchange/CIMaster";
import MessageMonitor from "./Messages Monitor/MessageMonitor";

const ReportsBody = () => {
  const { activeReportPage } = useGlobalContext();

  return (
    <div className="m-2">
      {activeReportPage === "Punctuality" ? <PunctualityNavMaster /> : null}
      {activeReportPage === "Operating Indices" ? <BestDataMaster /> : null}
      {/* {activeReportPage === "DRM`s Diary" ? <DRMDiaryMaster /> : null} */}
      {activeReportPage === "7A Loading" ? <SevenALoadingMaster /> : null}
      {activeReportPage === "Asset Failure" ? <AssetFailureMaster /> : null}
      {activeReportPage === "Other Reports" ? <OtherMaster /> : null}
      {activeReportPage === "DRM`s Diary New" ? <CompsMaster /> : null}
      {activeReportPage === "Milestones" ? <MilestoneMaster /> : null}
      {activeReportPage === "Operating performance" ? (
        <OperatingPerformance />
      ) : null}
      {activeReportPage === "CHC Report" ? <CIMaster /> : null}

      {/* {activeReportPage === "Ins Master" ? <InsMaster /> : null} */}
      {activeReportPage === "Message Monitor" ? <MessageMonitor /> : null}
    </div>
  );
};
export default ReportsBody;
